/* eslint-disable no-unused-vars */
import React from 'react';
import { useTheme } from '@mui/material';
import useStyles from './FormContent.styles.ts';
import Box, { BoxProps } from '@mui/material/Box';
import Switch from '@mui/material/Switch';
import { Typo } from '@/components/primitive';
import AddIcon from '@mui/icons-material/AddCircle';
import EditIcon from '@mui/icons-material/EditNote';
import GpsFixedIcon from '@mui/icons-material/GpsFixed';

type FormContentProps = {
  title: string;
  allowAutoFill?: boolean;
  bgcolor?: string;
  isAddress?: boolean;
  withEdit?: boolean;
  isEdit?: boolean;
  isAdd?: boolean;
  btnTitle?: string;
  titleStyle?: object;
  childContainerStyle?: object;
  editBtnContainerStyle?: object;
  toggleAutoFill?: (event: React.ChangeEvent<HTMLInputElement>) => void;
};

const FormContent: React.FC<FormContentProps & BoxProps> = ({
  title,
  bgcolor,
  allowAutoFill,
  toggleAutoFill,
  ...props
}) => {
  const theme = useTheme();
  const classes = useStyles(theme, bgcolor);

  return (
    <Box sx={classes.container}>
      <Box sx={classes.titleWrapper}>
        <Typo sx={props.titleStyle ?? classes.title}>{title}</Typo>
        {!!props.isAddress && (
          <Box sx={classes.addressContainer}>
            <Box sx={classes.editBtnContainer} onClick={props.onClick}>
              Use Current Location <GpsFixedIcon fontSize='small' />
            </Box>
            <Switch
              checked={Boolean(allowAutoFill)}
              onChange={toggleAutoFill ? toggleAutoFill : undefined}
              color='primary'
              name='allowAutofill'
              inputProps={{ 'aria-label': 'primary checkbox' }}
              size='small'
            />
            <Typo style={{ fontSize: 12, marginRight: '16px' }}>Address Autofill</Typo>
          </Box>
        )}
        {!!props.withEdit && props.isEdit && (
          <Box
            sx={props.editBtnContainerStyle ?? classes.editBtnContainer}
            style={{ marginRight: '16px' }}
            onClick={props.onClick}>
            {props.btnTitle}
            {props.isAdd ? <AddIcon fontSize='small' /> : <EditIcon fontSize='small' />}
          </Box>
        )}
      </Box>
      <Box sx={props.childContainerStyle ?? classes.wrapper}>{props.children}</Box>
    </Box>
  );
};

export default FormContent;
